const LAST_WORKSPACE_ID_KEY_SUFFIX = '_last_workspace_id';

export function getLastWorkspaceId(userId: string): string | null {
  return localStorage.getItem(`${userId}${LAST_WORKSPACE_ID_KEY_SUFFIX}`);
}

export function setLastWorkspaceId(userId: string, workspaceId: string) {
  localStorage.setItem(`${userId}${LAST_WORKSPACE_ID_KEY_SUFFIX}`, workspaceId);
}
